import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { BusinessPunchCardManagerHandler } from '../../providers/business-punch-card-handler';
import { BusinessPunchCardManagerPage } from '../business-punch-card-manager/business-punch-card-manager';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-punch-card-list',
  templateUrl: 'business-punch-card-list.html',
})
export class BusinessPunchCardListPage {
	punchCards: any;
	hasPunchCards: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;

	isRefreshing: boolean = false;

  constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		public punchCardManagerHandler: BusinessPunchCardManagerHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public globals: Globals,
		) {
		this.filePath = this.globals.fileUrl;
	}

	ionViewWillEnter() {
		this.load(null);
	}	

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	createPunchCard(){
	    this.navCtrl.push(BusinessPunchCardManagerPage, {
	      punchCard: {}
	    });		
	}

	managePunchCard($e, punchCard){
	    this.navCtrl.push(BusinessPunchCardManagerPage, {
	      punchCard: punchCard
	    });				
	}

	load(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;
		
		this.punchCardManagerHandler.getPunchCards((punchCards)=>{
			this.punchCards = punchCards;

			this.hasPunchCards = this.punchCards.length>0;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		})
	}

}


// WEBPACK FOOTER //
// ./src/pages/business-punch-card-list/business-punch-card-list.ts